import { NotificationManager} from 'react-notifications';

export const handleResponse = (response = {}) => {
	if(!response.success) {
		NotificationManager.error(response.message);
	}
	return null
}